import { render, staticRenderFns } from "./infos3.vue?vue&type=template&id=d2264538&scoped=true&"
import script from "./infos3.vue?vue&type=script&lang=js&"
export * from "./infos3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2264538",
  null
  
)

export default component.exports